import { connect, MapStateToProps } from 'react-redux'
import cartNameSelector from '../../redux/selectors/cart/cartNameSelector'
import cartNavLinkSelector from '../../redux/selectors/cart/cartNavLinkSelector'
import cartIsVisibleSelector from '../../redux/selectors/cart/cartIsVisibleSelector'
import { Props } from './Cartbox'
import cartIsLoadingSelector from '../../redux/selectors/is-loading/cartIsLoadingSelector'
import equipmentHaveAudiExclusiveSelector from '../../redux/selectors/equipmentHaveAudiExclusiveSelector'
import isAudiExclusivePdfVisibleSelector from '../../redux/selectors/feature-scope/isAudiExclusivePdfVisibleSelector'
import isDigitalGiveawayLinkVisibleSelector from '../../redux/selectors/feature-scope/isDigitalGiveawayLinkVisibleSelector'
import isUserGarageButtonVisibleSelector
    from '../../redux/selectors/garage/isUserGarageButtonVisibleSelector'
import cartAdditionalInformationSelector from '../../redux/selectors/cart/cartAdditionalInformationSelector'
import cartRemarksSelector from '../../redux/selectors/cart/cartRemarksSelector'
import displayPriceViewSwitcherSelector
    from '../../redux/selectors/view-properties/displayPriceViewSwitcherSelector'
import isTechnicalDataShoppingCartEnabledSelector from '../../redux/selectors/feature-scope/isTechnicalDataShoppingCartEnabledSelector'
import is3DExhibitionEnabledSelector from '../../redux/selectors/feature-scope/is3DExhibitionEnabledSelector'
import isSaveVehicleCodeVisible from '../../redux/selectors/feature-scope/isSaveVehicleCodeVisible'
import isSaveConfigurationButtonVisibleSelector from '../../redux/selectors/feature-scope/isSaveConfigurationButtonVisibleSelector'
import recommendationsBlockIsVisibleSelector from '../../redux/selectors/recommendations/recommendationsBlockIsVisibleSelector'

type StateProps = Pick<
    Props,
    | 'cartIsVisible'
    | 'cartName'
    | 'cartNavLink'
    | 'isLoading'
    | 'isAudiExclusivePdfVisible'
    | 'hasAudiExclusiveEquipments'
    | 'isDigitalGiveawayLinkVisible'
    | 'isUserGarageButtonVisible'
    | 'cartAdditionalInformation'
    | 'cartRemarks'
    | 'displayPriceViewSwitcher'
    | 'isTechnicalDataButtonVisible'
    | 'is3DExhibitionEnabled'
    | 'isSaveVehicleCodeVisible'
    | 'isSaveConfigurationButtonVisible'
    | 'hasRecommendationsAbove'
>

type OwnProps = Pick<Props, 'setE3DSharingVisible'>

const mapStateToProps: MapStateToProps<StateProps, OwnProps> = (state): StateProps => {

    return {
        cartIsVisible: cartIsVisibleSelector(state),
        cartName: cartNameSelector(state),
        cartNavLink: cartNavLinkSelector(state),
        isLoading: cartIsLoadingSelector(state),
        isAudiExclusivePdfVisible: isAudiExclusivePdfVisibleSelector(state),
        hasAudiExclusiveEquipments: equipmentHaveAudiExclusiveSelector(state),
        isDigitalGiveawayLinkVisible: isDigitalGiveawayLinkVisibleSelector(state),
        isUserGarageButtonVisible: isUserGarageButtonVisibleSelector(state),
        cartAdditionalInformation: cartAdditionalInformationSelector(state),
        cartRemarks: cartRemarksSelector(state),
        displayPriceViewSwitcher: displayPriceViewSwitcherSelector(state),
        isTechnicalDataButtonVisible: isTechnicalDataShoppingCartEnabledSelector(state),
        is3DExhibitionEnabled: is3DExhibitionEnabledSelector(state),
        isSaveVehicleCodeVisible: isSaveVehicleCodeVisible(state),
        isSaveConfigurationButtonVisible: isSaveConfigurationButtonVisibleSelector(state),
        hasRecommendationsAbove: recommendationsBlockIsVisibleSelector(state),
    }
}

export default connect<StateProps, {}, OwnProps>(mapStateToProps)
